export default __webpack_public_path__ + "static/media/document_black.849d1036.png";